import React, { lazy, useContext, Suspense } from "react";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import makeStyles from "@material-ui/styles/makeStyles";
import Button from "@material-ui/core/Button";
import WebProfileContext from "@WebProfileContext";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import localDE from "../../../locales/de.json";
import localEN from "../../../locales/en.json";

const ReactLink = lazy(() =>
	import(/* webpackChunkName: "reactLink" */ "@micado-digital/react-link/ReactLink")
);

const useStyles = makeStyles(theme => ({
	root: {
		display: "none",
		"& button": {
			fontSize: 14,
			transition: theme.transitions.create(["color"], {
				duration: theme.transitions.duration.complex
			}),
			[theme.breakpoints.up("sm")]: {
				fontSize: 16
			},
			[theme.breakpoints.up("lg")]: {
				fontSize: 23
			}
		},
		[theme.breakpoints.up("md")]: {
			display: "flex"
		},
		"& button:hover": {
			background: "none",
			color: theme.palette.secondary.main
		}
	}
}));

const Request = ({ fixed, lang, menuOpen }) => {
	const css = useStyles();
	const theme = useTheme();
	const [profileData] = useContext(WebProfileContext);
	const bigScreen = useMediaQuery(theme.breakpoints.up("lg"));
	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN
		}
	});

	const requestLink = profileData?.customLinks?.find(
		item => item?.identifier === "request"
	)?.url;

	return (
		<Suspense fallback={<></>}>
			<Box className={clsx("mco-header__request", css.root)}>
				<Suspense fallback={<></>}>
					<ReactLink to={requestLink}>
						<Button
							color={fixed || menuOpen ? "primary" : "secondary"}
							disableRipple={true}
							variant="text"
							size={bigScreen ? "medium" : "small"}
						>
							{l("header.buttonRequest")}
						</Button>
					</ReactLink>
				</Suspense>
			</Box>
		</Suspense>
	);
};

export default Request;
